import { Stack } from '@mui/material';

import { Text, api } from 'common';

import {
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../../ConfigFields/SelectField';

const PatientDataStore = api.FlowDefinition.PatientDataStore;

export const DocumentTranscriptionsVariant = {
  schema: PatientDataStore.DocumentTranscriptionsConfigSchema,
  Config: () => {
    return (
      <Stack spacing={2}>
        <Text variant="heading5" bold>
          Document Transcription
        </Text>
        <ParentBlockSelectField
          fieldName="config.documentMetadata.sourceBlockName"
          label="Document Metadata Source"
          required
          helperText={getSourceBlockNameHelperText('document metadata')}
        />
      </Stack>
    );
  },
};
